import templateUrl from "./news-category-main.html";

export const newsCategoryMainComponent = {
  templateUrl,
  bindings: {
    type: "@",
    title: "@",
    details: "<",
  },
  controller: class NewsCategoryMainComponent {
    constructor($state, toastr, NewsCategoryService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.NewsCategoryService = NewsCategoryService;
    }

    onSubmit() {
      this.NewsCategoryService.updateNewsCategory(this.details, this.type)
        .then((_) => {
          this.toastr.success("News Category Updated Successfully.");
          this.$state.go("newsCategory");
        })
        .catch((error) => {
          this.toastr.error(error.data.errors.message);
        });
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/components/news-category/news-category-main/news-category-main.component.js